export enum DocumentStatus {
	Imported="IMPORTED",
	Queued="QUEUED",
	Extracted="EXTRACTED",
	Validated="VALIDATED",
	Manual= "MANUAL",
	ReadyToExport = "READYTOEXPORT",
	Processed = "PROCESSED",
	Spam = "SPAM"
}
